<template lang="html">
<div class="table-cell">
  <slot>
    <p class="table-cell-name">{{cellData.label || cellData.name}}</p>
  </slot>
</div>
</template>

<script>
export default {
  name: 'TableCell',
  props: {
    cellData: { type: Object, default: null },
    cellIndex: { type: Number, default: -1 },
  },
}
</script>



// WEBPACK FOOTER //
// TableCell.vue?6b564bfb